import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Button, Panel, FormGroup, Checkbox } from 'react-bootstrap'
import autobind from 'autobind-decorator'
import _ from 'lodash'
import moment from 'moment'
import 'moment-range'
import VisitDetailsDialog from '../components/visitDetailsDialog'
import RoomDetailsDialog from '../components/roomDetailsDialog'
import { getAllRooms, getVisits, dashboard } from '../redux/actions'
import { changeProgramRoomVisibility } from '../redux/actions/dashboardActions'
import {
  dashboardDialogsSelector,
  dashboardStartDateSelector,
  dashboardEndDateSelector,
  eventsByRoomSelector,
  filteredRoomsSelector,
  programRoomsVisibleSelector,
  searchTextSelector,
  visitsLoadingSelector
} from '../redux/selectors/dashboardSelectors'
import LoadingSpinner from '../components/loader'
import DashboardRow from '../components/dashboard/dashboardRow'
import Input from '../components/elements/input'
import {
  continueTransfer,
  cancelTransfer,
  openAvailRoomsDialog,
  getRoomsForTransfer
} from '../redux/modules/roomTransferModule'
import TransferRoomsDialog from '../components/transferRoomsDialog'

const {
  changeDates,
  changeSearchText,
  closeVisitDialog,
  saveVisitDialog,
  changeVisitDialogValue,
  closeRoomDialog,
  saveRoomDialog,
  changeRoomDialogValue
} = dashboard

@autobind
class Dashboard extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    guests: PropTypes.object,
    rooms: PropTypes.object,
    visits: PropTypes.object,
    startDate: PropTypes.object,
    endDate: PropTypes.object,
    searchText: PropTypes.string,
    dialogs: PropTypes.object,
    isLoading: PropTypes.number
  }

  componentDidMount() {
    // getAllRooms now returns a promise (actions.js updated)
    this.props
      .dispatch(getAllRooms())
      .then(() => {
        this.props.dispatch(
          getVisits(this.props.startDate, this.props.endDate)
        );
      })
      .catch(err => console.error('Failed to load rooms', err));
  }

  onClickRefresh() {
    this.props.dispatch(
      getVisits(this.props.startDate.toDate(), this.props.endDate.toDate())
    )
  }

  onClickChangeMonth(action) {
    const changeFunc = action === 'prev' ? 'subtract' : 'add'
    const newMonthStart = this.props.startDate[changeFunc](1, 'month')
    const newMonthEnd = this.props.endDate[changeFunc](1, 'month').endOf(
      'month'
    )
    this.props.dispatch(
      changeDates({
        startDate: newMonthStart,
        endDate: newMonthEnd
      })
    )
    this.props.dispatch(getVisits(newMonthStart.toDate(), newMonthEnd.toDate()))
  }

  buildDashboardVisitDialog() {
    const { visits, guests, rooms, dialogs, dispatch } = this.props
    const dialog = dialogs.visit
    const dialogVisit = visits[dialog.visitId] || {}
    const dialogGuest = guests[dialogVisit.guest] || {}
    const dialogRoom = rooms[dialogVisit.roomId] || {}
    return (
      <VisitDetailsDialog
        {...dialog}
        onClose={() => dispatch(closeVisitDialog())}
        onChange={arg => dispatch(changeVisitDialogValue(arg))}
        onSave={() => dispatch(saveVisitDialog(dialog.edits))}
        visit={dialogVisit}
        guest={dialogGuest}
        room={dialogRoom}
      />
    )
  }

  buildDashboardRoomDialog() {
    const { rooms, dialogs, dispatch } = this.props
    const dialog = dialogs.room
    const dialogRoom = rooms[dialog.roomId] || {}
    return (
      <RoomDetailsDialog
        {...dialog}
        onClose={() => dispatch(closeRoomDialog())}
        onChange={arg => dispatch(changeRoomDialogValue(arg))}
        onSave={() => dispatch(saveRoomDialog(dialog.edits))}
        room={dialogRoom}
      />
    )
  }

  buildAvailRoomDialog() {
    return <TransferRoomsDialog />
  }

  cellContentFn = date => {
    return date.date()
  }

  weekContentFn = date => {
    return moment(date).format('dd')
  }

  render() {
    const {
      dispatch,
      startDate,
      endDate,
      searchText,
      programRoomsVisible,
      eventsByRoom,
      filteredRooms,
      isLoading,
      roomTransfer
    } = this.props

    const monthName = startDate.format('MMMM')
    const datesToDisplay = moment.range(startDate, endDate)

    return (
      <div id='dashboard'>
        <Panel>
          <table className='dashboard-table'>
            <thead>
              <tr>
                <td className='dashboard-room-name-head'>
                  <div
                    style={{
                      display: 'inline-block',
                      paddingLeft: '1rem',
                      marginBottom: 0
                    }}
                  >
                    <Button
                      bsStyle='primary'
                      onClick={() => this.onClickRefresh()}
                    >
                      Refresh
                    </Button>
                  </div>
                </td>
                <td
                  className='dashboard-table-head'
                  style={{ borderBottom: 'none', borderLeft: 'none' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1.5rem'
                    }}
                  >
                    <Button
                      bsStyle='primary'
                      onClick={() => this.onClickChangeMonth('prev')}
                    >
                      Prev
                    </Button>
                    <div className=''>
                      <FormGroup style={{ marginBottom: '10px' }}>
                        <Checkbox
                          checked={programRoomsVisible}
                          onChange={event =>
                            dispatch(
                              changeProgramRoomVisibility(event.target.checked)
                            )
                          }
                          style={{
                            display: 'inline-block',
                            paddingLeft: '1rem',
                            marginBottom: 0
                          }}
                        >
                          Show program rooms
                        </Checkbox>
                      </FormGroup>
                    </div>
                  </div>
                  <span>{monthName}</span>
                  <div>
                    <div
                      style={{
                        height: '2em',
                        float: 'left',
                        marginRight: '1.5em'
                      }}
                    >
                      <Input
                        type='text'
                        placeholder='Search'
                        value={searchText}
                        style={{
                          width: '10em',
                          float: 'left',
                          display: 'block'
                        }}
                        onChange={event =>
                          dispatch(changeSearchText(event.target.value))
                        }
                      />
                    </div>
                    {isLoading > 0 && (
                      <LoadingSpinner
                        style={{
                          width: '10em',
                          float: 'left',
                          display: 'block'
                        }}
                      />
                    )}
                    <Button
                      bsStyle='primary'
                      onClick={() => this.onClickChangeMonth('next')}
                      style={{ float: 'left' }}
                    >
                      Next
                    </Button>
                  </div>
                </td>
                <div className='dashboard-room-transfer-row'>
                  <td style={{ border: 'none' }}>
                    <div>
                      {roomTransfer.status === 'initial' && (
                        <Button
                          bsStyle={'primary'}
                          onClick={() => dispatch(continueTransfer())}
                        >
                          Start room transfer
                        </Button>
                      )}

                      <div style={{ display: 'flex', gap: '10px' }}>
                        {roomTransfer.status === 'active' && (
                          <Button
                            bsStyle={'primary'}
                            onClick={() => dispatch(cancelTransfer())}
                          >
                            Cancel transfer
                          </Button>
                        )}

                        {roomTransfer.status === 'active' && (
                          <Button
                            bsStyle={'primary'}
                            onClick={() => {
                              dispatch(getRoomsForTransfer())
                              dispatch(openAvailRoomsDialog())
                            }}
                          >
                            Get rooms for transfer
                          </Button>
                        )}

                        {roomTransfer.selectRoomWarning && (
                          <p
                            style={{
                              color: 'red',
                              margin: 0,
                              marginTop: '8px'
                            }}
                          >
                            Please select at least one visit to continue with
                            transfer
                          </p>
                        )}
                      </div>
                    </div>
                  </td>
                </div>
              </tr>
            </thead>
            <tbody>
              {/* week row  */}
              <DashboardRow
                room={{ name: '', isClean: true, id: 'weekRow' }}
                datesToDisplay={datesToDisplay}
                events={[]}
                cellContentFn={this.weekContentFn}
              />
              {/* rows  */}
              {filteredRooms.map((room, index) => (
                <DashboardRow
                  key={index}
                  room={room}
                  datesToDisplay={datesToDisplay}
                  events={eventsByRoom[room.id] || []}
                  cellContentFn={this.cellContentFn}
                  roomTransfer={roomTransfer}
                />
              ))}
            </tbody>
          </table>
          {this.buildDashboardVisitDialog()}
          {this.buildDashboardRoomDialog()}
          {this.buildAvailRoomDialog()}
        </Panel>
      </div>
    )
  }
}

// Which props do we want to inject, given the global state?
function selectProps(state) {
  return {
    eventsByRoom: eventsByRoomSelector(state),
    filteredRooms: filteredRoomsSelector(state),
    rooms: state.rooms,
    visits: state.visits,
    guests: state.guests,
    startDate: dashboardStartDateSelector(state),
    endDate: dashboardEndDateSelector(state),
    searchText: searchTextSelector(state),
    programRoomsVisible: programRoomsVisibleSelector(state),
    dialogs: dashboardDialogsSelector(state),
    isLoading: visitsLoadingSelector(state),
    roomTransfer: state.roomTransfer
  }
}

// Wrap the component to inject dispatch and state into it
export default connect(selectProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/containers/dashboard.js